import { useCallback, useRef, useState } from "react";
import { toast } from "react-toastify";
// * hooks
import { useBrandUploadMutation } from "../hooks/fileUploadMutation";
import { useAuth } from "../services/auth";
// * component
import Uploader from "../components/Uploader";

const HomeScreen = () => {
  const { authData } = useAuth();

  const brandNameRef = useRef<HTMLInputElement>(null);
  const onSuccessUpload = useCallback(() => {
    if (brandNameRef.current) {
      brandNameRef.current.value = "";
    }
    setObjectKeys([]);
    toast.success("Registration success");
  }, []);

  const [objectKeys, setObjectKeys] = useState<string[]>([]);
  const { mutate: uploadBrandMutate, isLoading: uploadLoading } =
    useBrandUploadMutation(authData?.token ?? "", onSuccessUpload);

  return (
    <div className="py-[38px] px-[28px] h-full bg-backgroundSecondary">
      <div className="px-[29px] h-[54px] w-2/3 rounded-md shadow-md bg-backgroundTertiary flex flex-col justify-center text-bg01 font-semibold">
        Add Brand
      </div>
      <div className="mt-[32px] px-[29px] py-[27px] w-2/3 rounded-md shadow-md bg-backgroundTertiary">
        <div className="text-bg01 font-semibold">New Brand Registration</div>
        <div className="mt-[22px] text-black">Brand Name*</div>
        <input
          ref={brandNameRef}
          placeholder="Enter Brand Name"
          className="mt-2 px-[15px] py-[8px] w-1/2 rounded-md border border-primary bg-backgroundPrimary text-sm"
        />
        <div className="mt-[30px] text-black">Upload Attachment</div>
        <Uploader
          value={objectKeys}
          setValue={setObjectKeys}
          additionalClass="mt-2"
        />
        <div className="mt-[80px] flex flex-row">
          <div
            onClick={() => {
              const brandName = brandNameRef.current?.value ?? "";
              if (
                uploadLoading ||
                objectKeys.length === 0 ||
                brandName === ""
              ) {
              } else {
                uploadBrandMutate({
                  brandName,
                  objectKey: objectKeys[0],
                });
              }
            }}
            className="w-[120px] h-[44px] rounded bg-bg01 text-backgroundTertiary flex flex-col justify-center items-center cursor-pointer hover:opacity-80"
          >
            Add
          </div>
          <div className="ml-4 w-[120px] h-[44px] rounded bg-backgroundPrimary text-primary flex flex-col justify-center items-center cursor-pointer hover:opacity-80">
            Cancel
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeScreen;
